module.exports = __webpack_public_path__ + "static/img/time_down.35d22fdd.png";